import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getSocialRelationshipTargetIdentityUserPublicID,
  type SocialRelationshipDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const relationshipKeys = {
  all: ["SOCIAL_RELATIONSHIP"] as const,
  byTarget: (identityUserPublicID: string) =>
    [...relationshipKeys.all, identityUserPublicID] as const,
};

/**
 * The caller's relationship to a persona — server-computed capabilities drive the
 * profile-page buttons. Skipped for anonymous viewers (the endpoint is authenticated).
 */
export const useRelationshipQuery = (
  identityUserPublicID: string | undefined,
) =>
  useQuery<SocialRelationshipDto>({
    queryKey: relationshipKeys.byTarget(identityUserPublicID ?? ""),
    queryFn: identityUserPublicID
      ? processResponseWithApiProblemDetails(() =>
          getSocialRelationshipTargetIdentityUserPublicID(identityUserPublicID),
        )
      : skipToken,
  });
